export interface ConsentTypeProps {
  type: 'privacy' | 'marketing';
  name: string;
  id: string;
}

export const consentConfig: Record<string, ConsentTypeProps> = {
  privacy: {
    type: 'privacy',
    name: 'privacy consent',
    id: 'isPrivacyConsentOptedIn',
  },
  marketing: {
    type: 'marketing',
    name: 'marketing communications consent',
    id: 'isMarketingConsentOptedIn',
  },
  age: { type: 'privacy', name: 'age consent', id: 'isAgeConsentOptedIn' },
};

export interface ConsentOptionChangeTracking {
  eventName: 'option_selection_pressed';
  optionSelectionType: 'checkbox';
  optionSelected: 'unchecked' | 'checked';
  optionSelectionName: string;
  isPrivacyConsentOptedIn?: boolean;
  isMarketingConsentOptedIn?: boolean;
}
